export { ConsoleAdapter } from './ConsoleAdapter';
export { DebugAdapter } from './DebugAdapter';
export type { LogAdapter } from './LogAdapter';
